import { computed } from 'vue';
import { useCheckoutStore } from '@/stores/checkout';
import { useRoute } from 'vue-router';
import { useGettext } from 'vue3-gettext';
import { usePageContext } from 'vike-vue/usePageContext';

export const useCheckoutTitle = () => {
  const checkoutStore = useCheckoutStore();
  const route = useRoute();
  const { $gettext } = useGettext();
  const pageContext = usePageContext();

  const eventName = computed(() => checkoutStore?.getSelectedEvent?.name);
  const venueName = computed(() => checkoutStore?.getSelectedEvent?.venue?.name);
  const pageName = computed(() => {
    let name;
    switch (route.name) {
      case 'OrderNew':
        name = $gettext('Tickets');
        break;

      case 'OrderPayment':
        name = $gettext('Checkout');
        break;

      case 'OrderFinalize':
        name = $gettext('Processing Payment');
        break;

      case 'OrderConfirmation':
        name = $gettext('Confirmation');
        break;
    }
    return name;
  });

  const title = computed(() =>
    [eventName.value, venueName.value, pageName.value, pageContext.brandName || 'VenuePilot'].filter(v => v).join(' • '),
  );

  return {
    title,
  };
};
